import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Menu: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M21 19H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2Zm0-6H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2Zm0-6H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2Z" />
  </Icon>
);

export default Menu;
